/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {Components as ɵa} from './components/root';